var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnused(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4688 18.4688C19.75 18.1875 20.2188 18.1875 20.5 18.4688L21.9688 19.9688L23.4688 18.4688C23.75 18.1875 24.2188 18.1875 24.5 18.4688C24.8125 18.7812 24.8125 19.25 24.5 19.5312L23.0312 21L24.5 22.4688C24.8125 22.7812 24.8125 23.25 24.5 23.5312C24.2188 23.8438 23.75 23.8438 23.4688 23.5312L21.9688 22.0625L20.5 23.5312C20.2188 23.8438 19.75 23.8438 19.4688 23.5312C19.1562 23.25 19.1562 22.7812 19.4688 22.4688L20.9375 21L19.4688 19.5312C19.1562 19.25 19.1562 18.7812 19.4688 18.4688ZM30 21C30 25.4375 26.4062 29 22 29C17.5625 29 14 25.4375 14 21C14 16.5938 17.5625 13 22 13C26.4062 13 30 16.5938 30 21ZM22 14.5C18.4062 14.5 15.5 17.4375 15.5 21C15.5 24.5938 18.4062 27.5 22 27.5C25.5625 27.5 28.5 24.5938 28.5 21C28.5 17.4375 25.5625 14.5 22 14.5Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnused);
export default __webpack_public_path__ + "static/media/unused.7cdf966a064d7bd308e7d8d22283bc41.svg";
export { ForwardRef as ReactComponent };